import React from 'react'

const EmptyState = ({
  title = 'Nothing here yet',
  description = 'When items appear, they will show up in this list.',
  action,
}) => (
  <div className="nx-panel-soft flex flex-col items-center justify-center gap-2 px-6 py-14 text-center">
    <p className="font-display text-2xl tracking-wide text-paper">{title}</p>
    <p className="max-w-md text-sm text-muted">{description}</p>
    {action && <div className="mt-3">{action}</div>}
  </div>
)

export default EmptyState
